export const MessageSkeleton = () => (
    <div className="flex animate-pulse items-center gap-4 rounded border bg-white p-3 dark:border-icoDarkMode-beton dark:bg-icoDarkMode-anthracite">
        {/* Avatar skeleton */}
        <div className="bg-icoGray-200 h-14 w-14 rounded-lg bg-icoGray-300 dark:bg-icoDarkMode-beton" />

        <div className="flex-1 space-y-2">
            {/* Header skeleton */}
            <div className="flex justify-between">
                <div className="bg-icoGray-200 h-3 w-1/4 rounded bg-icoGray-300 dark:bg-icoDarkMode-beton" />
                <div className="bg-icoGray-200 h-3 w-20 rounded bg-icoGray-300 dark:bg-icoDarkMode-beton" />
            </div>

            {/* Content skeleton */}
            <div className="space-y-2">
                <div className="bg-icoGray-200 h-3 w-3/4 rounded bg-icoGray-300 dark:bg-icoDarkMode-beton" />
                <div className="bg-icoGray-200 h-3 w-1/2 rounded bg-icoGray-300 dark:bg-icoDarkMode-beton" />
            </div>
        </div>
    </div>
);
